import { createSelector } from '@reduxjs/toolkit';
import { ICoverageDetails } from 'app/models/UserCoverage/UserCoverage';
import { RootState } from "types";
import { initialState } from "./slice";
import { filterCurrentlyActiveCoverage } from './coverageEffectiveNow';

const selectDomain = (state: RootState) => state?.coverage || initialState;

export const selectRequestedCoverage = createSelector([selectDomain], coverage => coverage.requestedCoverage);

export const selectActiveCoverage = createSelector([selectDomain], coverage => coverage.activeCoverage);

/**
 * Approved coverages whose [startDate, endDate] includes `at` (default: now). Not wrapped in `createSelector` — time
 * is not Redux input, so memoization would freeze the effective window. Use `useActiveCoverageForTaskActions` in
 * components; use this for tests (pass `at`) or rare non-React call sites.
 */
export function selectActiveCoverageForTaskActions(
  state: RootState,
  at: Date = new Date(),
): ICoverageDetails[] {
  return filterCurrentlyActiveCoverage(selectActiveCoverage(state), at);
}

export const selectRequestsGridData = createSelector([selectDomain], coverage => coverage.coverageRequestsGridData);

export const selectCoverageDeskChips = createSelector([selectDomain], coverage => coverage.chips);

export const selectCoverageCreatedId = createSelector([selectDomain], coverage => coverage.newCreatedCoverageId);

export const selectCoverageUpdatedId = createSelector([selectDomain], coverage => coverage.updatedCoverageId);

export const selectDenyCoverageId = createSelector([selectDomain], coverage => coverage.denyCoverage);

export const selectCoveredEmails = createSelector([selectDomain], coverage => coverage?.emailCoverage);

export const selectCoveredInbox = createSelector([selectDomain], coverage=> coverage.inboxCoverage);